var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var ExportIcon = function (props) { return (_jsx("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M2.5 15.8333H17.5V17.5H2.5V15.8333ZM10.8333 4.85667V14.1667H9.16667V4.85667L4.1075 9.91667L2.92917 8.73833L10 1.66667L17.0708 8.7375L15.8925 9.91583L10.8333 4.85833V4.85667Z", fill: "currentColor" }) }))); };
